import { memo } from "react";

import { type BillingStatus, type TicketListAvailable_BillingPageQuery } from "@/lib/gql/__generated__/graphql";

import { FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { BasicTicketCurrentStatusSection } from "./section/current-status";
import { BasicTicketPurchaseTicketSection } from "./section/purchase-ticket";

import type {
	BillingSettingDialogStateType,
	BillingSettingDialogType,
	OnUpdatePurchaseBasicBillingTicketType,
} from "../../../../../../model/use-case";

type Props = {
	hotelID: string;

	ticketBasicListAvailable: TicketListAvailable_BillingPageQuery["ticketBasicListAvailable"];

	billingStatus: BillingStatus;
	onPurchaseBasicBillingTicket: OnUpdatePurchaseBasicBillingTicketType;

	openBillingSettingDialog: BillingSettingDialogStateType;
	handleOpenChange: (type: BillingSettingDialogType) => (callBackFunc: NodeJS.Timeout) => (open: boolean) => void;
	activateBillingSettingDialog: (type: BillingSettingDialogType) => void;
	deactivateBillingSettingDialog: (type: BillingSettingDialogType) => void;
};

export const IslandBasicTicket = memo(
	({
		hotelID,
		ticketBasicListAvailable,
		billingStatus,
		onPurchaseBasicBillingTicket,

		openBillingSettingDialog,
		handleOpenChange,
		activateBillingSettingDialog,
		deactivateBillingSettingDialog,
	}: Props) => {
		return (
			<>
				<FeatureIslandMainWithBackGround islandTitle="基本料金">
					<BasicTicketCurrentStatusSection billingStatus={billingStatus} />

					<BasicTicketPurchaseTicketSection
						hotelID={hotelID}
						billingStatus={billingStatus}
						onPurchaseBasicBillingTicket={onPurchaseBasicBillingTicket}
						ticketBasicListAvailable={ticketBasicListAvailable}
						openBillingSettingDialog={openBillingSettingDialog}
						handleOpenChange={handleOpenChange}
						activateBillingSettingDialog={activateBillingSettingDialog}
						deactivateBillingSettingDialog={deactivateBillingSettingDialog}
					/>
				</FeatureIslandMainWithBackGround>
			</>
		);
	},
);

IslandBasicTicket.displayName = "IslandBasicTicket";
